const LAZY_LOAD_VIEW = (path) => () =>
  import(
    /* webpackChunkName: "view-operations-materials-and-equipments-transfer-[request]" */ `@/views/pei/materials-and-equipments-transfer/${path}`
  );

export const MATERIALS_AND_EQUIPMENTS_TRANSFER_ROUTES = [
  {
    path: 'materials-and-equipments-transfer',
    component: LAZY_LOAD_VIEW`Wrapper.vue`,
    children: [
      {
        path: '',
        name: 'materials-and-equipments-transfer',
        component: LAZY_LOAD_VIEW`Main.vue`,
      },
    ],
  },
];
